import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import API_BASE_URL from './api'
import { useTranslation } from 'react-i18next';
import { getLangFromPath, buildPathWithLang } from './i18n/lang';

export default function ResetPassword() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const email = params.get('email');
  const code  = params.get('code');
  const [newPwd, setNewPwd] = useState('');
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const lang = getLangFromPath(window.location.pathname);

  const handleSubmit = async e => {
    e.preventDefault();
    setMsg(null);
    let res, json;
    try {
      const API = (API_BASE_URL || '').replace(/\/+$/, '');
      res = await fetch(`${API}/reset-password`, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ email, code, new_password: newPwd })
      });
      json = await res.json();
    } catch {
      setMsg(t('reset.network_error'));
      return;
    }

    if (json && (json.success || res.status === 200)) {
      setMsg(t('reset.success_redirect'));
      setTimeout(() => navigate(buildPathWithLang(lang, '/login')), 2000);
    } else {
      setMsg(json?.detail || json?.message || t('reset.error_generic'));
    }
  };

  if (!email || !code) {
    return <p>{t('reset.bad_link')}</p>
  }

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', padding: 20, background: '#fff', borderRadius: 8 }}>
      <h2>{t('reset.title_for_email', { email })}</h2>
      {msg
        ? <p>{msg}</p>
        : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 12 }}>
              <input
                type="password"
                placeholder={t('reset.new_password_placeholder')}
                value={newPwd}
                onChange={e => setNewPwd(e.target.value)}
                minLength={6}
                required
                style={{ width: '100%', padding: 8, fontSize: 16 }}
              />
            </div>
            <button type="submit" style={{ width: '100%', padding: 10, fontSize: 16 }}>
              {t('reset.change_password')}
            </button>
          </form>
        )
      }
    </div>
  )
}
